






































import { Vue, Component, Prop } from 'vue-property-decorator';
import { TextWithImageBlockViewModel } from '@/types/contentServerContract';
import SmartHeadline from '@/core/ui-components/SmartHeadline.vue';
import { extensionIsGifOrUndefined } from '@/project/shared/responsive-umbraco-image.service';

@Component({
    components: { SmartHeadline }
})
export default class TextWithImageBlock extends Vue {
    @Prop({
        required: true,
        type: Object
    }) content!: TextWithImageBlockViewModel;

    @Prop({
        required: true,
        type: Boolean
    }) isFirstBlock!: boolean;

    get headlineColor() {
        return this.content.headlineColor ?? null;
    }

    get subHeadlineColor() {
        return this.content.subHeadlineColor ?? null;
    }

    get textColor() {
        return this.content.textColor ?? null;
    }

    get imageFormat(): string | undefined {
        return extensionIsGifOrUndefined(this.content?.image);
    }
}
